// extracted by mini-css-extract-plugin
export const layout = "layout-module--layout--3NElS";
export const footer = "layout-module--footer--3iD_9";